// extracted by mini-css-extract-plugin
export default {"imgdiv":"ed2e281754 _8a987c7078","img":"_3209c46289 _61cc7bd4e2"};